import React from 'react';
import { StyleSheet } from 'react-native';
import { Surface } from 'react-native-paper';
import { TabId } from './types';
import { TreeNode } from '../TreeView';
import {
    DrawingsTab,
    LineMapTab,
    ModelTab,
    NodeSummaryTab
} from '../TabComponents';

interface TabContentProps {
    tabId: TabId;
    selectedNode: TreeNode | null;
    projectData: any;
}

// Simple component to display tab content
export const TabContent: React.FC<TabContentProps> = ({ tabId, selectedNode, projectData }) => {
    const renderContent = () => {
        switch (tabId) {
            case 'drawings':
                return <DrawingsTab selectedNode={selectedNode} projectData={projectData} />;
            case 'lineMap':
                return <LineMapTab selectedNode={selectedNode} projectData={projectData} />;
            case '3dModel':
                return <ModelTab selectedNode={selectedNode} projectData={projectData} />;
            case 'nodeSummary':
                return <NodeSummaryTab selectedNode={selectedNode} projectData={projectData} />;
            default:
                return null;
        }
    };

    return (
        <Surface style={styles.container}>
            {renderContent()}
        </Surface>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
});
